import { Component, createElement } from 'react';
import { get, omit } from 'lodash-es';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { pageDefinition } from 'site-modules/shared/pages/page';
import {
  VehicleModel,
  VehicleEntities,
  buildVehiclePath,
  buildDefaultVehiclePath,
} from 'client/data/models/vehicle-v2';
import { buildVehiclePath as buildGraphqlVehiclePath, VehicleGraphQLModel } from 'client/data/models/vehicle-graphql';
import { updateVehicle, buildContextVehicleFromMakeModelSubmodelYear } from 'client/actions/vehicle';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { isUsed as isUsedPubState } from 'site-modules/shared/utils/publication-states';

const mapDispatchToProps = dispatch => ({
  /**
   * @param makeModelSubmodelYear
   */
  updateVehicle: makeModelSubmodelYear => {
    const isUsed = isUsedPubState(get(makeModelSubmodelYear, 'pubStates', {}));
    const vehicleForContext = buildContextVehicleFromMakeModelSubmodelYear(makeModelSubmodelYear, { isUsed });
    dispatch(updateVehicle(vehicleForContext));
  },
});

export function corePageDecorator(options, params) {
  const { component } = options;
  const isCore7661Test = options?.options?.isCore7661Test;
  const isCore7646Test = options?.options?.isCore7646Test;

  class CorePageComponentUI extends Component {
    constructor(props) {
      super(props);
      const vehicle = props.vehicle || props.vehicleGraphql;

      this.props.updateVehicle(vehicle);

      this.newParams = !params.year ? { ...params, year: vehicle?.year } : params;
    }

    render() {
      return createElement(component, {
        ...omit(this.props, ['vehicle', 'vehicleGraphql']),
        vehicle: this.props.vehicle || this.props.vehicleGraphql,
        params: this.newParams,
      });
    }
  }

  CorePageComponentUI.propTypes = {
    ...component.propTypes,
    vehicle: VehicleEntities.MakeModelSubmodelYear,
    vehicleGraphql: VehicleEntities.MakeModelSubmodelYear,
    updateVehicle: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  };

  CorePageComponentUI.defaultProps = {
    vehicle: null,
    vehicleGraphql: null,
  };

  const mapStateToProps = state => ({
    isCore7661Enabled: isCore7661Test && !!state.featureFlags?.['core-7661-gql-vehicle'],
    isCore7646Enabled: isCore7646Test && !!state.featureFlags?.['core-7646-used-graphql-vehicle'],
  });

  const CorePageComponent = withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      connectToModel(CorePageComponentUI, {
        vehicle: bindToPath(
          ({ isCore7661Enabled, isCore7646Enabled }) =>
            !isCore7661Enabled &&
            !isCore7646Enabled &&
            (params.year ? buildVehiclePath(params) : buildDefaultVehiclePath(params)),
          VehicleModel
        ),
        vehicleGraphql: bindToPath(
          ({ isCore7661Enabled, isCore7646Enabled }) =>
            (isCore7661Enabled || isCore7646Enabled) && buildGraphqlVehiclePath(params),
          VehicleGraphQLModel
        ),
      })
    )
  );

  return pageDefinition({
    ...options,
    component: CorePageComponent,
  });
}
